export const assetPermissions = [
  // Assets
  {
    id: 1,
    menu: "Filters",
    operation: "AHU Machines",
    permissions: { 1: false, 2: false, 3: false },
  },
  {
    id: 2,
    menu: "Filters",
    operation: "AHU Filters",
    permissions: { 1: false, 2: false, 3: false },
  },

  // Reports
  {
    id: 3,
    menu: "Reports",
    operation: "Reports",
    permissions: { 1: false, 2: false, 3: false },
  },

  // Audit Log
  {
    id: 4,
    menu: "Audit Log",
    operation: "Activity Log",
    permissions: { 1: false, 2: false, 3: false },
  },

  // Admin
  {
    id: 5,
    menu: "Admin",
    operation: "Users",
    permissions: { 1: false, 2: false, 3: false },
  },
  {
    id: 6,
    menu: "Admin",
    operation: "Permissions",
    permissions: { 1: false, 2: false, 3: false },
  },
  // Master
  {
    id: 7,
    menu: "Master",
    operation: "Filter Types",
    permissions: { 1: false, 2: false, 3: false },
  },
  {
    id: 8,
    menu: "Master",
    operation: "Audit Activities",
    permissions: { 1: false, 2: false, 3: false },
  },
  {
    id: 9,
    menu: "Master",
    operation: "Filter Activities",
    permissions: { 1: false, 2: false, 3: false },
  },
  {
    id: 10,
    menu: "Master",
    operation: "Maintenance Stages",
    permissions: { 1: false, 2: false, 3: false },
  }
];

